import React, { useEffect, useMemo } from 'react';
import anmaticsLogo from '../images/new/logo-ui.png';

const Home = () => {
    const words = useMemo(() => [
        { label: "SaaS Platforms", color: "#2563EB" },
        { label: "AI Workflows", color: "#14B8A6" },
        { label: "Enterprise Apps", color: "#7B2CBF" },
        { label: "Product Teams", color: "#F97316" }
    ], []);
    const [text, setText] = React.useState("");
    const [index, setIndex] = React.useState(0);
    const [subIndex, setSubIndex] = React.useState(0);
    const [deleting, setDeleting] = React.useState(false);
    const currentWord = words[index] || words[0];

    useEffect(() => {
        if (index === words.length) setIndex(0);

        if (
            subIndex === words[index].label.length + 1 &&
            !deleting
        ) {
            setTimeout(() => setDeleting(true), 1500);
            return;
        }

        if (subIndex === 0 && deleting) {
            setDeleting(false);
            setIndex((prev) => (prev + 1) % words.length);
            return;
        }

        const timeout = setTimeout(() => {
            setSubIndex((prev) => prev + (deleting ? -1 : 1));
        }, deleting ? 50 : 120);

        return () => clearTimeout(timeout);
    }, [subIndex, index, deleting, words]);

    useEffect(() => {
        setText(words[index].label.substring(0, subIndex));
    }, [subIndex, index, words]);

    return (
        <section className="home hero-section position-relative" id="home">
            <div className="hero-overlay"></div>
            <div className="hero-particles"></div>
            <div className="container overflow-hidden mt-8 mt-lg-4 p-2 p-md-12" data-aos="zoom-in">
                <div className="row py-8 text-center text-lg-start align-items-center">
                    <div className="col-lg-8 d-flex flex-column justify-content-center hero-text" data-aos="zoom-in" data-aos-delay="200">
                        <div className="hero-text">
                            <h1 className="display-4 fw-bold mt-4 mb-2 futuristic-text">
                                Build Reliable Software
                            </h1>
                            <div className="display-4 fw-bold mb-2 futuristic-text hero-title-line">
                                for <span className="highlighted-word" style={{ '--word-accent': currentWord.color }}>{text}</span>
                                <span className="blinking-cursor" style={{ '--word-accent': currentWord.color }}>|</span>
                            </div>
                            <p className="lead mb-5 futuristic-subtext">
                                Anmatics helps companies design, modernize, and scale secure web, mobile, SaaS, and AI-enabled systems with clear architecture and disciplined delivery.
                            </p>
                            <div className="hero-actions d-flex flex-column flex-sm-row gap-3 justify-content-center justify-content-lg-start">
                                <a href="#contact" className="btn btn-gradient btn-lg rounded-pill shadow-lg">
                                    Book a Technical Consultation
                                </a>
                                <a href="#services" className="btn btn-secondary-brand btn-lg rounded-pill">
                                    Explore Services
                                </a>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 d-flex justify-content-lg-end" data-aos="fade-up" data-aos-delay="700">
                        <div className="hero-system-visual hero-blueprint-visual" aria-label="Anmatics engineering blueprint visual">
                            <div className="system-visual-body">
                                <div className="blueprint-orbit blueprint-orbit-one"></div>
                                <div className="blueprint-orbit blueprint-orbit-two"></div>
                                <div className="blueprint-core">
                                    <img
                                        src={anmaticsLogo}
                                        alt=""
                                        aria-hidden="true"
                                        width="42"
                                        height="42"
                                        loading="lazy"
                                        decoding="async"
                                    />
                                    <span>Anmatics</span>
                                    <strong>Engineering Blueprint</strong>
                                </div>
                                <div className="blueprint-node blueprint-node-discover">
                                    <span>01</span>
                                    <strong>Discover</strong>
                                </div>
                                <div className="blueprint-node blueprint-node-architect">
                                    <span>02</span>
                                    <strong>Architect</strong>
                                </div>
                                <div className="blueprint-node blueprint-node-engineer">
                                    <span>03</span>
                                    <strong>Engineer</strong>
                                </div>
                                <div className="blueprint-node blueprint-node-scale">
                                    <span>04</span>
                                    <strong>Scale</strong>
                                </div>
                                <div className="blueprint-capability-list">
                                    <div>
                                        <span>SaaS</span>
                                        <strong>Product systems</strong>
                                    </div>
                                    <div>
                                        <span>AI</span>
                                        <strong>Workflow automation</strong>
                                    </div>
                                    <div>
                                        <span>Cloud</span>
                                        <strong>APIs & scale</strong>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Home;
